// extracted by mini-css-extract-plugin
export default {"faded":"_2VRNO"};